import { Box } from '@chakra-ui/react';
import { headerHeight } from '@udacity/udacity-header-v2';

import { StayPostedForm } from '~/features/ai-marketer/components/stay-posted-form';
import { COPY, STAY_UP_TO_DATE_SECTION_ID } from '~/features/ai-marketer/constants';
import { FooterBannerSection } from '~/features/page-template/templates/enterprise-overview/components/footer-banner-section';

export function StayPostedSection() {
  return (
    <Box id={STAY_UP_TO_DATE_SECTION_ID} scrollMarginTop={headerHeight}>
      <FooterBannerSection
        backgroundColor='#000'
        ctaSlot={<StayPostedForm />}
        description={COPY.stayPosted.description}
        textMaxWidth={{ base: '100%', md: '476px' }}
        title={COPY.stayPosted.title}
        backgroundImages={{
          mobile: '/images/ai-marketer/footer-banner-mobile.webp',
          desktop: '/images/ai-marketer/footer-banner-desktop.webp',
          mobileStyle: { objectPosition: 'top right' },
          desktopStyle: { objectPosition: 'right top' },
        }}
      />
    </Box>
  );
}
